module.exports = __webpack_public_path__ + "static/media/sidebar-agent-management-selected.4751aa33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-agent-management-selected.svg
// module id = 810
// module chunks = 0